import { useEffect } from 'react';
import { createGlobalStyle, useTheme } from 'styled-components';
import { useThemeValues } from 'styles/theme';
import { ThemeType } from 'styles/themes/KCFTheme';

function useGlobalThemeStylesComponent() {
    const { colorMode } = useTheme();
    const theme = useThemeValues();

    useEffect(() => {
        if (colorMode === ThemeType.dark) {
            document.getElementsByTagName('html')[0].classList.add('theme-dark');
        } else {
            document.getElementsByTagName('html')[0].classList.remove('theme-dark');
        }
    }, [colorMode]);

    // for more conditional styles, use `.theme-dark` in App.scss
    return createGlobalStyle`
    html, *[aria-modal="true"], button, nav, [role="radiogroup"], .kcf-page-layout {
    --disabled-text-color: ${theme.disabledText} !important;
    --primary-box-shadow: ${theme.primaryBoxShadow} !important;
    --modal-box-shadow: ${theme.modalBoxShadow} !important;
    --input-border-color: ${theme.inputBorder} !important;
    --input-border-focused-color: ${theme.inputBorderFocused} !important;
    --input-border-valid-color: ${theme.inputBorderValid} !important;
    --input-border-invalid-color: ${theme.inputBorderInvalid} !important;
    --primary-text-color: ${theme.primaryText} !important;
    --secondary-text-color: ${theme.secondaryText} !important;
    --background-color: ${theme.backgroundColor} !important;
    --link-color: ${theme.link} !important;
    --active-background-color: ${theme.backgroundColorActive} !important;
    --border-color: ${theme.borderColor} !important;
    --cancel-button-color: ${theme.cancelButton} !important;
    --cancel-button-hover-color: ${theme.cancelButtonHover} !important;
    --delete-button-color: ${theme.deleteButton} !important;
    --delete-button-hover-color: ${theme.deleteButtonHover} !important;
    --tab-selected-color: ${theme.tabSelected} !important;
    }
    *[aria-modal="true"] {
        background-color: var(--background-color);
    }
`;
}

export function GlobalThemeStyles() {
    const Component = useGlobalThemeStylesComponent();

    return <Component />;
}
